import * as React from 'react';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import { ThemeProvider, GlobalStyles } from '@mui/material';
import { HeaderProps, Header } from '@cv/core-ui';
import { primaryTheme } from '@cv/core-ui';
import { CacheProvider, EmotionCache } from '@emotion/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { styleFixes } from './style-fixes';

interface MaterialHeaderProps extends HeaderProps {
  cache: EmotionCache;
  addGlobal?: boolean;
}

export const MaterialHeader = (props: MaterialHeaderProps) => {
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <CacheProvider value={props.cache}>
        <ThemeProvider theme={primaryTheme}>
          <ScopedCssBaseline>
            {/* We have some global styles from cvweb we need to override as they are affecting material ui styles */}
            {props.addGlobal && <GlobalStyles styles={styleFixes} />}
            <Header {...props} />
          </ScopedCssBaseline>
        </ThemeProvider>
      </CacheProvider>
    </QueryClientProvider>
  );
};
